import { CompleteFlightRefundBody, ConfirmFlightRefundBody, FetchFlightRefundParams, FlightRefund, ListData } from "@/types";
import axiosInstance from "./api";

export async function fetchListFlightRefundService(
  params: FetchFlightRefundParams,
): Promise<ListData<FlightRefund>> {
  return axiosInstance
    .get("/flight-booking-cancellation", { params })
    .then((response) => response.data);
}

export async function confirmFlightRefundService(
  body: ConfirmFlightRefundBody,
): Promise<void> {
  return axiosInstance
    .patch(`/flight-booking-cancellation/admin/handle-flight-refunds/${body.id}`, { ...body })
    .then((response) => response.data);
}

export async function completeFlightRefundService(
  body: CompleteFlightRefundBody,
): Promise<void> {
  return axiosInstance
    .patch(`/flight-booking-cancellation/admin/complete-flight-refund/${body.id}`, { ...body })
    .then((response) => response.data);
}